import { createClientCommand } from "./createClient";
import type { Command } from "./types";

export const COMMANDS: Command[] = [createClientCommand];

export function matchCommands(
  query: string,
  commands: Command[] = COMMANDS,
): Command[] {
  const normalized = query.trim().toLowerCase();

  if (!normalized) {
    return commands;
  }

  return commands.filter((command) => {
    const haystack = [
      command.id,
      command.label.message,
      ...(command.keywords ?? []),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return haystack.includes(normalized);
  });
}
